import { useContext } from "react";
import { ThemeContext } from "@/providers/ThemeProvider";

// ---------------------- Hook

export const useTheme = () => {
  // --------- Variables / Hooks

  const context = useContext(ThemeContext);

  if (context === undefined) {
    throw new Error("useTheme must be used within a ThemeProvider");
  }

  return context;
};
